import React from 'react';
import Item from '../DropdownItem/DropdownItem';
import { IconHeartL, IconThumbsUpL, IconMoneyL } from '../../../../icons';
import config from '../../../../config';
import {
    INTEREST_RIDING,
    INTEREST_WALK,
    INTEREST_CARE,
} from '../../../../marketplace-custom-config';
import DropdownItemWithListingsData from './DropdownItemWithListingsData';

const { listingTypeHorse, userTypeRider } = config;

export default () => (
    <>
        <DropdownItemWithListingsData
            heading="Reitbeteiligung"
            searchParams={{
                pub_type: listingTypeHorse,
                pub_activities: [INTEREST_RIDING],
            }}
        />
        <DropdownItemWithListingsData
            heading="Spazierbeteiligung"
            searchParams={{
                pub_type: listingTypeHorse,
                pub_activities: [INTEREST_WALK],
            }}
        />
        <DropdownItemWithListingsData
            heading="Pflegebeteiligung"
            searchParams={{
                pub_type: listingTypeHorse,
                pub_activities: [INTEREST_CARE],
            }}
        />
        <Item name="FindHorsePage">
            <Item.Icon>
                <IconThumbsUpL />
            </Item.Icon>
            <Item.Content>
                <Item.Heading>Alle Vorteile</Item.Heading>
                <Item.Description>Funktionen im Überblick</Item.Description>
            </Item.Content>
        </Item>
        <Item name="MatchingPage" searchParams={{ role: userTypeRider }}>
            <Item.Icon>
                <IconHeartL />
            </Item.Icon>
            <Item.Content>
                <Item.Heading>Matching</Item.Heading>
                <Item.Description>So funktioniert es</Item.Description>
            </Item.Content>
        </Item>
        <Item name="PricingPage" searchParams={{ role: userTypeRider }}>
            <Item.Icon>
                <IconMoneyL />
            </Item.Icon>
            <Item.Content>
                <Item.Heading>Preise</Item.Heading>
                <Item.Description>Volle Transparenz</Item.Description>
            </Item.Content>
        </Item>
    </>
);
